import { Flex } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ErrorLouiseOffer } from '../../../../../types/Quotes';
import { RootState } from '../../store/redux/reducers/rootReducer';
import SingleOfferErrorMessage from './SingleOfferErrorMessage';
import SingleOfferMainButton from './SingleOfferMainButton';
import { SummaryContainer } from './SingleOfferSummaryContainer';
import OfferActionLink from '../OfferActionLink';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

interface Props {
  refetch: () => void;
  onReport: () => void;
  isFetching?: boolean;
  offer: ErrorLouiseOffer;
  showErrorModal?: boolean;
}

const SingleOfferError: React.FC<React.PropsWithChildren<Props>> = ({
  refetch,
  onReport,
  isFetching,
  offer,
  showErrorModal,
}) => {
  const { t } = useTranslation();

  const offerCombinationError = useSelector(
    (state: RootState) =>
      state.offers.offersInfo.offerCombinationError[offer.hash_id],
  );

  return (
    <SummaryContainer>
      <Flex
        flexDir="column"
        alignItems="center"
        margin="auto"
        alignSelf="flex-end"
      >
        <SingleOfferErrorMessage offer={offer} />
      </Flex>
      {!isSocialLoginUrl && (
        <OfferActionLink onClick={onReport}>
          {t('Report error with this offer')}
        </OfferActionLink>
      )}
      <SingleOfferMainButton
        onClick={refetch}
        isLoading={!showErrorModal && isFetching}
        disabled={offerCombinationError}
        hasError
      >
        {t('Try again')}
      </SingleOfferMainButton>
    </SummaryContainer>
  );
};

export default SingleOfferError;
